import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { Users, BookOpenCheck } from 'lucide-react';
import './CommunitySection.css';

function CommunitySection() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  return (
    <section className="community-section">
      <div className="parallax-bg"></div>
      <div className="content-container">
        <div className={`community-content ${inView ? 'animate' : ''}`} ref={ref}>
          <h1>UNLOCK HIDDEN POTENTIAL</h1>
          <div className="description">
            <p>
              Many students are brilliant but held back by poor communication.
              They understand English but hesitate to speak due to shyness or lack of fluency.
            </p>
            <p>
              Boldly English helps break that barrier by building confidence and unlocking their voice.
            </p>
          </div>

          <div className="stats-container">
            {/* Registered Learners */}
            <div className="stat-box">
              <div className="stat-icon">
                <Users size={80} />
              </div>
              <div className="stat-numbers">
                {inView && (
                  <span>
                    <CountUp
                      start={0}
                      end={800}
                      duration={2.5}
                      separator=","
                      useEasing={true}
                      useGrouping={true}
                    />
                    <span style={{ fontWeight: 'bold', marginLeft: '2px' }}>+</span>
                  </span>
                )}
              </div>
              <div className="stat-label">Registered Learners</div>
            </div>

            {/* Classes Completed */}
            <div className="stat-box">
              <div className="stat-icon">
                <BookOpenCheck size={80} />
              </div>
              <div className="stat-numbers">
                {inView && (
                  <span>
                    <CountUp
                      start={0}
                      end={1000}
                      duration={2.5}
                      separator=","
                      useEasing={true}
                      useGrouping={true}
                    />
                    <span style={{ fontWeight: 'bold', marginLeft: '2px' }}>+</span>
                  </span>
                )}
              </div>
              <div className="stat-label">Classes Completed</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CommunitySection;
